import { PeriodCodeType } from '@types'

export const PERIODS_MAP: Record<PeriodCodeType, string> = {
  day: 'DAY',
  week: 'WEEK TO DATE',
  month: 'MONTH TO DATE',
  quarter: 'QUARTER TO DATE',
  year: 'YEAR TO DATE',
}
